import React, { useState, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import { ReactComponent as DeleteIcon } from "../../../../../assets/utils/images/svgs/Delete.svg";
import { ReactComponent as UploadIcon } from "../../../../../assets/utils/images/svgs/Upload.svg";
import { toast } from "react-toastify";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { useUploadProfilePhoto,useDeleteProfileImage } from "Api/Coordinator/Gebruikers/Algemeen";

const Photo = () => {
	const { userDetails, currentUser, disable } = useGebruikerContext();
	const existingProfilePic = userDetails?.profileImage;
	const {
		trigger: updateProfilePhoto,
		isMutating: uploadingPhoto,
	} = useUploadProfilePhoto();

	 const {
			trigger: deleteProfileImage,
			isMutating: isDeletingImage,
		} = useDeleteProfileImage(userDetails?.iAdminId);

	const [userImg, setUserImg] = useState("");
	useEffect(() => {
		if (existingProfilePic) {
			setUserImg(`${existingProfilePic}`);
		}
	}, [existingProfilePic]);

	const handleImageUpload = (event) => {
		const file = event.target.files[0];
		if (file) {
			// Check file size (2MB)
			const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
			const validTypes = ["image/png", "image/jpeg", "image/bmp"];

			if (file.size > maxSizeInBytes) {
				toast.error("Bestandsgrootte mag niet groter zijn dan 2MB.");
				return;
			}

			if (!validTypes.includes(file.type)) {
				toast.error("Ongeldig bestandsformaat. Alleen PNG, JPG, en BMP zijn toegestaan.");
				return;
			}

			const reader = new FileReader();
			reader.onloadend = () => {
				setUserImg(reader.result);
				updateUserProfile(file);
			};
			reader.readAsDataURL(file);
		}
	};

	  const handleDeleteImage = async () => {
        try {
            await deleteProfileImage();
            setUserImg("");
        } catch (error) {
            console.error("Failed to delete profile image:", error);
        }
    };

	const updateUserProfile = (value) => {
		const formData = new FormData();
		formData.append("iAdminId", currentUser.data.clooserId);
		formData.append("file", value);

		updateProfilePhoto({ data: formData })
			.then((response) => {
				if (response.status) return;
				if (!response.success) {
					const errors = response.data.file;
					if (Array.isArray(errors)) {
						toast.error(errors.join(","));
					} else {
						toast.error(errors);
					}
				}
			})
			.catch((error) => {
				console.error("API error:", error);
			});
	};


	return (
		<Card className="main-card h-110">
			<CardBody className="d-flex flex-column">
				<h5 className="mb-4">{userImg ? "Foto" : "Foto toevoegen"}</h5>
				<div className="user-img text-center mx-auto my-auto">
					{userImg ? (
						<div className="img-box">
							<img src={userImg} alt="img" />
							 <button
                               onClick={handleDeleteImage}
                            >
								<DeleteIcon />
							</button>
						</div>
					) : (
						<div className="img-input">
							<input type="file" accept="image/*" onChange={handleImageUpload} disabled={disable || uploadingPhoto}
								style={disable || uploadingPhoto ? { pointerEvents: 'none' } : {}} />
							<div className="mb-2">
								<UploadIcon />
							</div>
							<p>Sleep of klik op het icoon om foto toe te voegen</p>
							<p>Toegestane bestandsformaten: *.jpg, *.png, *.bmp</p>
						</div>
					)}
				</div>
			</CardBody>
		</Card>
	);
};

export default Photo;
